<script setup>
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useBackend } from '@/composables/Backend';

const router = useRouter();
const route = useRoute();
const backend = useBackend();

onMounted(async () => {
  const { code, state, error } = route.query;
  const response = await backend.callback(code, state, error); // Await fetch
  const data = await response.json();

  if (data.success && data.redirectUrl) {
    window.location.href = data.redirectUrl; // Full reload for /my-account
  } else if (data.redirectUrl) {
    window.location.href = data.redirectUrl;
  } else {
    console.error('Callback error:', data.message);
    router.push('/login'); // Fallback
  }

  // if (data.success) {
  //   router.push(data.redirectUrl); // redirects to account dashboard: my-account
  // } else if (data.redirectUrl) {
  //   window.location.href = data.redirectUrl; // Shopify OAuth Login
  // } else {
  //   console.error('Callback error:', data.message);
  //   router.push('/login'); // Fallback
  // }
});
</script>

<template>
  <div>Loading...</div>
</template>